module.exports = __webpack_public_path__ + "static/media/main-board-nolight.9f35a341.png";